import styled from 'styled-components';

import { body } from '@constants/fonts';

export const Arrow = styled.div`
  background-color: ${({ theme }) => theme.palette.grey['900']};
  position: absolute;
  height: 10px;
  width: 10px;
  left: -4px;
  top: calc(50% - 5px);
  transform: rotate(45deg);
  z-index: -1;
`;

export const ToolTipStyle = styled.div<{ visible: boolean }>`
  background-color: ${({ theme }) => theme.palette.grey['900']};
  font-family: ${body};
  font-size: 14px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 5px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.palette.grey['50']};
  position: absolute;
  left: calc(100% + 10px);
  word-break: none;
  width: auto;
  top: calc(50% - 20px);
  z-index: 1;
  white-space: nowrap;

  max-width: ${(p) => (p.visible ? 'auto' : '0')};
  padding: ${(p) => (p.visible ? '10px' : '10px 0')};
  opacity: ${(p) => (p.visible ? 1 : 0)};
  overflow: ${(p) => (p.visible ? 'visible' : 'hidden')};

  transition: all 0.2s ease-in;
`;
